// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilityFamily {
    static getAttributeTypeMap() {
        return MedicalEligibilityFamily.attributeTypeMap;
    }
}
MedicalEligibilityFamily.discriminator = undefined;
MedicalEligibilityFamily.additionalProperties = false;
MedicalEligibilityFamily.attributeTypeMap = [
    {
        "name": "coInsurance",
        "baseName": "coInsurance",
        "type": "string"
    },
    {
        "name": "deductible",
        "baseName": "deductible",
        "type": "string"
    },
    {
        "name": "deductibleMet",
        "baseName": "deductibleMet",
        "type": "string"
    },
    {
        "name": "deductibleOutNetwork",
        "baseName": "deductibleOutNetwork",
        "type": "string"
    },
    {
        "name": "deductibleRemaining",
        "baseName": "deductibleRemaining",
        "type": "string"
    },
    {
        "name": "oop",
        "baseName": "oop",
        "type": "string"
    },
    {
        "name": "oopMet",
        "baseName": "oopMet",
        "type": "string"
    },
    {
        "name": "oopOutNetwork",
        "baseName": "oopOutNetwork",
        "type": "string"
    },
    {
        "name": "oopRemaining",
        "baseName": "oopRemaining",
        "type": "string"
    },
];
//# sourceMappingURL=medicalEligibilityFamily.js.map